import { Container, Row, Col, Button, } from 'react-bootstrap';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <Container>
        <Row className='text-center py-3'>
          <Col>
            <p>QuickAccounts &copy; {currentYear}</p>
            <Button variant="primary" onClick={() => window.location.href = '/'}>Go to Homepage</Button>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
export default Footer;
